var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 12.9991C13.0516 12.9991 13.4991 12.5516 13.4991 11.9996C13.4991 11.4475 13.0516 11 12.4996 11C11.9475 11 11.5 11.4475 11.5 11.9996C11.5 12.5516 11.9475 12.9991 12.4996 12.9991Z",
    stroke: "#141414",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 5.99912C13.0516 5.99912 13.4991 5.55161 13.4991 4.99956C13.4991 4.44752 13.0516 4 12.4996 4C11.9475 4 11.5 4.44752 11.5 4.99956C11.5 5.55161 11.9475 5.99912 12.4996 5.99912Z",
    stroke: "#141414",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 19.9991C13.0516 19.9991 13.4991 19.5516 13.4991 18.9996C13.4991 18.4475 13.0516 18 12.4996 18C11.9475 18 11.5 18.4475 11.5 18.9996C11.5 19.5516 11.9475 19.9991 12.4996 19.9991Z",
    stroke: "#141414",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreVertical);
export default __webpack_public_path__ + "static/media/icon_more_vertical.315025a8b339781b8d518cf17601ca97.svg";
export { ForwardRef as ReactComponent };